var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('McmErrorPage',{attrs:{"error":_vm.error,"logoTitle":_vm.$t('views.notFound.breadcrumb')}})}
var staticRenderFns = []

export { render, staticRenderFns }